// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2JYwc","title":"Images90_title__23cGF","images":"Images90_images__1oRus"};